<template>
  <div>
    <el-row :gutter="20">
      <!-- 左侧：仓库列表 -->
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="handleShopHouseSelect('')"
              :class="{ 'selected': queryStockManageInfo.conditions.shId === '' }">
              全部
            </li>
            <li v-for="(item, index) in queryStockManageInfo.shopHouses" :key="index"
              @click="handleShopHouseSelect(item.shId)"
              :class="{ 'selected': queryStockManageInfo.conditions.shId === item.shId }">
              {{ item.shName }}
            </li>
          </ul>
        </el-card>
      </el-col>

      <!-- 右侧：查询条件和表格 -->
      <el-col :span="21">
        <!-- 查询条件 -->
        <el-card class="ibox">
          <div slot="header" class="flex justify-between">
            <span>查询条件</span>
          </div>
          <div class="">
            <el-form :inline="true" :model="queryStockManageInfo.conditions" class="flex justify-start">
              <el-form-item>
                <el-input v-model="queryStockManageInfo.conditions.prodName" placeholder="请输入商品名称" clearable />
              </el-form-item>
              <el-form-item>
                <el-input v-model="queryStockManageInfo.conditions.productId" placeholder="请输入商品编号" clearable />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="_queryShopHouseMethod">
                  <i class="el-icon-search"></i> 查询
                </el-button>
                <el-button @click="_resetShopHouseMethod">
                  <i class="el-icon-refresh"></i> 重置
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>

        <!-- 库存查询表格 -->
        <el-card class="margin-top-sm">
          <div slot="header" class="flex justify-between">
            <span>库存查询</span>
          </div>
          <div class="card-body">
            <el-table :data="queryStockManageInfo.inoutOrders" border style="width:100%">
              <el-table-column prop="shName" label="仓库" align="center" />
              <el-table-column prop="prodName" label="商品名称" align="center" />
              <el-table-column prop="defaultSpecValue.specName" label="商品规格" align="center" />
              <el-table-column prop="productId" label="商品编号" align="center" />
              <el-table-column prop="defaultSpecValue.stock" label="库存" align="center" />
              <el-table-column prop="warnStock" label="库存警告" align="center" />
            </el-table>

            <el-pagination @current-change="handleCurrentChange" :current-page="queryStockManageInfo.conditions.page"
              :page-size="queryStockManageInfo.conditions.row" layout="total, prev, pager, next"
              :total="queryStockManageInfo.total" style="margin-top:20px" />
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryProductStock, queryShopHouse } from '@/api/goods/queryWarnStockApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      queryStockManageInfo: {
        inoutOrders: [],
        shopHouses: [],
        total: 0,
        records: 1,
        moreCondition: false,
        shId: '',
        curOrder: {},
        conditions: {
          warnFlag: '1',
          prodName: '',
          shId: '',
          productId: '',
          shopId: getShopId(),
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._initMethod()
  },
  methods: {
    _initMethod() {
      this._listInoutOrder(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
      this._listShopHouses()
    },
    handleCurrentChange(val) {
      this._listInoutOrder(val, this.DEFAULT_ROWS)
    },
    async _listInoutOrder(_page, _rows) {
      this.queryStockManageInfo.conditions.page = _page
      this.queryStockManageInfo.conditions.row = _rows

      const params = {
        ...this.queryStockManageInfo.conditions,
        productId: this.queryStockManageInfo.conditions.productId.trim(),
        prodName: this.queryStockManageInfo.conditions.prodName.trim()
      }

      try {
        const res = await queryProductStock(params)
        this.queryStockManageInfo.total = res.total
        this.queryStockManageInfo.records = res.records
        this.queryStockManageInfo.inoutOrders = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _queryShopHouseMethod() {
      this._listInoutOrder(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _resetShopHouseMethod() {
      this.queryStockManageInfo.conditions.prodName = ""
      this.queryStockManageInfo.conditions.productId = ""
      this.queryStockManageInfo.conditions.shId = ""
      this._listInoutOrder(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    handleShopHouseSelect(shId) {
      this.queryStockManageInfo.conditions.shId = shId
      this.queryStockManageInfo.conditions.page = 1
      this._listInoutOrder(1, this.DEFAULT_ROWS)
    },
    async _listShopHouses() {
      const params = {
        page: 1,
        row: 100,
        shopId: getShopId()
      }

      try {
        const res = await queryShopHouse(params)
        this.queryStockManageInfo.shopHouses = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
}

.margin-top-sm {
  margin-top: 20px;
}
</style>